import React from 'react';
import { NavLink } from 'react-router-dom';
import useCategories from '../Admin/useCategories';
import HScroller from '../common/HScroller';
import { assetUrl } from '../../config/api';
import './Categorysection.scss';

/**
 * Horizontal category rail shown directly beneath the header.
 *
 * The previous version also rendered a duplicate dropdown listing the same
 * categories, keyed by array index, and imported a cut/shape hook it never
 * used (an extra request on every page). The rail itself is the navigation.
 * It scrolls sideways with arrow controls once it outgrows the viewport.
 */
const Categorysection = ({ collapsedOnMobile = false }) => {
  const { categories, loading, error } = useCategories();

  if (error) return null;

  return (
    <nav
      className={`ij-catbar${collapsedOnMobile ? ' ij-catbar--home' : ''}`}
      aria-label="Product categories"
    >
      <div className="ij-catbar__inner">
        <HScroller label="categories" variant="bar" align="start">
          {loading ? (
            <div className="ij-catbar__skeletons" aria-hidden="true">
              {Array.from({ length: 6 }, (_, index) => (
                <span
                  key={index}
                  className="ij-skeleton"
                  style={{ width: 88, height: 18, borderRadius: 999 }}
                />
              ))}
            </div>
          ) : (
            <ul className="ij-catbar__list">
              <li>
                <NavLink
                  to="/allproducts"
                  className={({ isActive }) =>
                    `ij-catbar__link${isActive ? ' is-active' : ''}`
                  }
                >
                  All products
                </NavLink>
              </li>
              {categories.map((category) => (
                <li key={category.category_code}>
                  <NavLink
                    to={`/category?category=${category.category_code}`}
                    className="ij-catbar__link"
                  >
                    {category.category_image && (
                      <img
                        className="ij-catbar__thumb"
                        src={assetUrl(category.category_image)}
                        alt=""
                        loading="lazy"
                        decoding="async"
                      />
                    )}
                    {category.category_name}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </HScroller>
      </div>
    </nav>
  );
};

export default Categorysection;
